// modules/LotDescription.js
import React        from 'react';
// import renderHTML   from 'react-render-html';

class LotDescription extends React.Component {
	constructor(props) {
		super(props);

		this.displayPrice    = this.displayPrice.bind(this);
	}

	displayPrice() {
		if ( this.props.lot.lot_hot_lot !== 1 ) {
			return (
				<div className="lot-description-text-price">${this.props.lot.lot_price_formatted}</div>
			)
		} else {
			return (
				<div className="lot-description-text-price hotlot">
					${this.props.lot.lot_hot_lot_price_formatted}
					<div className="hotlot-splash">
						ON SALE!
					</div>
				</div>
			)
		}
	}


	render() {
		return (
			<div className="lot-description-block">
				<div className="lot-title">Lot {this.props.title}</div>
				<div className="lot-description-text">{this.props.lot.lot_area}m<sup>2</sup> &nbsp; - &nbsp; {this.displayPrice()}</div>
				<div>
					<div className="lot-description-left">
						Frontage <span>{this.props.lot.lot_frontage}m</span><br/>
						Depth <span>{this.props.lot.lot_depth}m</span>
					</div>
					<div className="lot-description-right">
						Easements: <span>{this.props.lot.lot_easements}</span><br/>
						BAL: <span>{this.props.lot.lot_bushfire_attack_level}</span><br/>
						Noise Attenuation: <span>{this.props.lot.lot_noise_attenuation}</span>
					</div>
					<div className="clear-div"></div>
				</div>

				{/*<div>{renderHTML(this.props.children)}</div>*/}
				<br/>
			</div>
		);
	}
}

export default LotDescription;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/LotDescription.js
 **/